import { USER_MANAGEMENT_ASSET_NAMES } from '../../../iac/constants';

export type AdminInfo = {
  isAdmin: boolean;
  isGroupAdmin: boolean;
  isSystemAdmin: boolean;
};

export const getAdminInfo = (roles: string[]): AdminInfo => {
  const cleanRoles = roles ?? [];
  const isGroupAdmin = cleanRoles.includes(USER_MANAGEMENT_ASSET_NAMES.GROUPS.GROUP_ADMIN);
  const isSystemAdmin = cleanRoles.includes(USER_MANAGEMENT_ASSET_NAMES.GROUPS.ADMIN);
  const isAdmin = isGroupAdmin || isSystemAdmin;

  return {
    isAdmin,
    isGroupAdmin,
    isSystemAdmin,
  };
};
